<template>
  <v-navigation-drawer v-model="drawer"
                       :width="$valueByBreakpoint($finSideNav.width)"
                       app
                       class="fin-side-navigation-drawer fin-color-primary-dark"
                       dark
                       permanent
                       style="max-height: 100vh;"
                       touchless
  >
    <!-- Nav-Header -->
    <template #prepend>
      <div style="text-align: center; padding: 12px;">
        <logo-sign border class="logo"/>
      </div>
    </template>

    <v-divider class="mx-4 mb-6"/>

    <!-- Navigation -->
    <fin-scrollable-list class="nav-content fin-color-primary-dark">
      <!-- Main-Navigation -->
      <v-list-item v-for="item in routes"
                   :key="item.name"
                   :class="`${item.class} px-0 ${item.id}`"
                   :link="!item.disabled"
                   :to="item.disabled ? null : item.to"
                   @click="sideMenuItemClicked(item)"
      >
        <v-list-item-content class="nav-link">
          <v-icon :class="item.disabled ? 'nav-icon color-disabled' : 'nav-icon color-enabled'">{{ item.icon }}</v-icon>
          <v-list-item-title :class="item.disabled ? 'link-text color-disabled' : 'link-text color-enabled'">
            {{ item.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </fin-scrollable-list>
  </v-navigation-drawer>
</template>

<script>
import logoSign from '@/components/common/logo/LogoSign'
import AmplitudePush from "@/mixins/AmplitudePush"

export default {
  name: 'FinSideNavigation',
  components: {
    logoSign
  },
  mixins: [AmplitudePush],
  props: {
    routes: {
      type: Array
    }
  },
  data() {
    return {
      drawer: false
    }
  },
  methods: {
    sideMenuItemClicked(item) {
      this.pushToAmplitude({
        'event': item.event,
        'step': item.step,
        'placement': item.placement,
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })

    }
  }
}
</script>

<style lang="scss" scoped>
@import "SideNavigation";

.logo {
  color: transparent !important;
}

hr {
  background-color: $divider-color;
}

.color-enabled,
.nav-icon.color-enabled:before {
  color: #fff !important;
}

.color-disabled {
  color: rgba(255, 255, 255, 0.6) !important;
}
</style>
